module.exports = __webpack_public_path__ + "static/img/5-1.59e2484.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/5-1.png
// module id = 667
// module chunks = 140